/**
 * product-mobile-slider.js
 * Handles mobile-specific product media gallery behaviour:
 * - Sets the --app-height CSS custom property for accurate 100vh on iOS.
 * - Scroll-to-info scroll detection at the bottom of the media wrapper.
 * - Bullet navigation dots that track the visible media item.
 */

document.addEventListener('DOMContentLoaded', () => {
  // ── App height (iOS 100vh fix) ─────────────────────────────────────────────
  if (window.innerWidth <= 750) {
    const setAppHeight = () => {
      document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', setAppHeight);
    setAppHeight();
  }

  // ── Scroll-to-info at bottom of media wrapper ──────────────────────────────
  const slider = document.querySelector('.product__media-wrapper');
  if (slider) {
    slider.addEventListener('scroll', () => {
      if (window.innerWidth > 750) return;
      const maxScrollTop = slider.scrollHeight - slider.clientHeight;
      if (slider.scrollTop >= maxScrollTop - 2) {
        const nextElement = document.querySelector('.product__info-wrapper');
        if (nextElement) {
          nextElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  // ── Bullet navigation dots ─────────────────────────────────────────────────
  try {
    if (window.innerWidth > 750) return;

    const bulletsContainer = document.querySelector('.bullets');
    const images = document.querySelectorAll('.product__media-item');
    if (!bulletsContainer || images.length === 0) return;

    images.forEach((img, idx) => {
      const bullet = document.createElement('button');
      bullet.className = 'bullet';
      bullet.type = 'button';
      bullet.dataset.index = idx;
      if (idx === 0) bullet.classList.add('active');

      bullet.addEventListener('click', () => {
        bulletsContainer.querySelectorAll('.bullet').forEach(b => b.classList.remove('active'));
        bullet.classList.add('active');
        try {
          img.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_e) {
          // silent – browser may not support smooth scrolling
        }
      });

      bulletsContainer.appendChild(bullet);
    });

    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (mediaWrapper) {
      mediaWrapper.addEventListener('scroll', () => {
        try {
          let activeIdx = 0;
          let minDiff = Infinity;
          const wrapperTop = mediaWrapper.getBoundingClientRect().top;
          images.forEach((img, idx) => {
            const diff = Math.abs(img.getBoundingClientRect().top - wrapperTop);
            if (diff < minDiff) { minDiff = diff; activeIdx = idx; }
          });
          bulletsContainer.querySelectorAll('.bullet').forEach((b, i) => {
            b.classList.toggle('active', i === activeIdx);
          });
        } catch (e) {
          console.error('Erreur pendant le scroll du slider', e);
        }
      }, { passive: true });
    }
  } catch (e) {
    console.error('Erreur initialisation bullets', e);
  }
});

window.addEventListener('load', () => {
  try {
    const bulletsContainer = document.querySelector('.bullets');
    if (!bulletsContainer) return;
    const bulletsBlockHeight = bulletsContainer.clientHeight || 0;
    bulletsContainer.style.setProperty('--sizeBulletsBlock', `${bulletsBlockHeight}px`);
  } catch (e) {
    console.error('Erreur lors du calcul de la hauteur des bullets', e);
  }
});
